export enum AssemblyType {
  All = 0,
  Internal = 1,
  External = 2,
  InternalWithoutAssembler = 3
}